import axios from 'axios';

export default class AuthService {

    performAccountRegistration(payload) {

        if(payload){
            //Define Welcome Coupon Data for registering account.
            payload.supplierRefId=process.env.VUE_APP_SUPPLIER_REF_ID?process.env.VUE_APP_SUPPLIER_REF_ID:null;
            /* 
                No longer submitting client define coupon amt.
                Commented couponAmt setting code.
            */
            //payload.couponAmt=process.env.VUE_APP_AMT1?process.env.VUE_APP_AMT1:null;
        }
        
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/register',
            payload
        ).then(res => res.data);
    }

    performLogin(email,password) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/login',
            {
                loginKey: email,
                password:password
            }
        ).then(res => res.data);
    }

    initLogin(accKey,accPass) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/login-init',
            {
                accKey: accKey,
                accPass: accPass
            }
        ).then(res => res.data);
    }

    initLoginWithPhone(countryCode,phone,accPass) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/login-init-with-phone',
            {
                countryCode: countryCode,
                phone: phone,
                accPass: accPass
            }
        ).then(res => res.data);
    }

    reqLoginOtp(accKey,otpChannel,otpChallenge) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/request-login-otp',
            {
                accKey: accKey,
                otpChallenge: otpChallenge,
                otpChannel: otpChannel
            }
        ).then(res => res.data);
    }

    reqLoginOtpWithPhone(countryCode,phone,otpChannel,otpChallenge) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/request-login-otp-with-phone',
            {
                countryCode: countryCode,
                phoneNumber:phone,
                otpChallenge: otpChallenge,
                otpChannel: otpChannel
            }
        ).then(res => res.data);
    }

    completeLogin(accKey,otpChannel,loginChallenge,otp) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/complete-login',
            {
                accKey: accKey,
                loginChallenge: loginChallenge,
                otpChannel: otpChannel,
                otp: otp
            }
        ).then(res => res.data);
    }

    completeLoginWithPhone(countryCode,phone,otpChannel,loginChallenge,otp) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/complete-login-with-phone',
            {
                countryCode: countryCode,
                phoneNumber:phone,
                loginChallenge: loginChallenge,
                otpChannel: otpChannel,
                otp: otp
            }
        ).then(res => res.data);
    }

    reqCaptchaRegister() {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/request-captcha-reg'
        ).then(res => res.data);
    }

    reqCaptchaLogin(accKey,otpChallenge) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/request-captcha-login',
            {
                accKey: accKey,
                otpChallenge: otpChallenge,               
            }
        ).then(res => res.data);
    }

    reqCaptchaLoginWithPhone(countryCode,phone,otpChallenge) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/request-captcha-login-with-phone',
            {
                countryCode: countryCode,
                phoneNumber:phone,
                otpChallenge: otpChallenge,               
            }
        ).then(res => res.data);
    }

    completeCaptchaLogin(accKey,captchaValue,captchaPhrase,loginChallenge) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/complete-captcha-login',
            {
                accKey: accKey,                
                captchaValue: captchaValue,
                captchaPhrase: captchaPhrase,
                loginChallenge: loginChallenge
            }
        ).then(res => res.data);
    }

    completeCaptchaLoginWithPhone(countryCode,phone,captchaValue,captchaPhrase,loginChallenge) {
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/mfa/complete-captcha-login-with-phone',
            {
                countryCode: countryCode,
                phoneNumber:phone,            
                captchaValue: captchaValue,
                captchaPhrase: captchaPhrase,
                loginChallenge: loginChallenge
            }
        ).then(res => res.data);
    }

    sendPasswordResetRequestByEmail(email){
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/request-reset-password-by-email',
            {
                registeredEmail: email
            }
        ).then(res => res.data);
    }

    resetPasswordByEmail(payload){
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/reset-password-by-email',
            payload
        ).then(res => res.data);
    }

    sendPasswordResetRequestByPhone(code,phNumber){
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/request-reset-password-by-phone',
            {
                countryCode: code, phoneNumber: phNumber
            }
        ).then(res => res.data);
    }

    resetPasswordByPhone(payload){
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/reset-password-by-phone',
            payload
        ).then(res => res.data);
    }


    performLogout() {
        let accessToken= sessionStorage.getItem('access_token');
        return axios.get(process.env.VUE_APP_API_ROOT+'/user/logout',{
                headers:{
                    'Authorization': 'Bearer '+accessToken
                }
            }
        ).then(res => res.data);
    }

    performRefresh() {
        let refreshToken= localStorage.getItem('refresh_token');
        return axios.get(process.env.VUE_APP_API_ROOT+'/user/refresh',{
                headers:{
                    'Authorization': 'Bearer '+refreshToken
                }
            }
        ).then(res => res.data);
    }

    fetchAuthUserProfile() {
        let accessToken= sessionStorage.getItem('access_token');
        return axios.get(process.env.VUE_APP_API_ROOT+'/user/get-profile',{
                headers:{
                    'Authorization': 'Bearer '+accessToken
                }
            }
        ).then(res => res.data);
    }

    performUpdateInfo(payload){
        let accessToken= sessionStorage.getItem('access_token');
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/update-info',
            payload,
            {
                headers:{'Authorization': 'Bearer '+accessToken}
            }
        ).then(res => res.data);
    }

    performUpdateEmail(payload){
        let accessToken= sessionStorage.getItem('access_token');
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/update-email',
            payload,
            {
                headers:{'Authorization': 'Bearer '+accessToken}
            }
        ).then(res => res.data);
    }

    performUpdatePassword(payload){
        let accessToken= sessionStorage.getItem('access_token');
        return axios.post(process.env.VUE_APP_API_ROOT+'/user/update-password',
            payload,
            {
                headers:{'Authorization': 'Bearer '+accessToken}
            }
        ).then(res => res.data);
    }

}